module.exports = __webpack_public_path__ + "assets/icons/ic_local_offer-0bb3.svg";